import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { BaseView, BaseText } from '@/components/base'
import { RowItem } from '@/components/RowItem'
import { Separator } from '@/components/Separator'
import { Toggle } from '@/components/Toggle'
import { useSavingsStore } from '@/store/useSavingsStore'
import {
  useGetEstimateSavingTransferOutFee,
  useGetFeaturesSettings,
} from '@/domain'

export const TransferOutSettingsAndFees: React.FC = () => {
  const [isInstantTransfer, setIsInstantTransfer] = useState(false)

  const { t } = useTranslation()

  const goalTransferOut = useSavingsStore((state) => state.goalTransferOut)
  const setGoalTransferOut = useSavingsStore(
    (state) => state.setGoalTransferOut,
  )

  const {
    data: transferOutFees,
    isLoading: isLoadingTransferOutFees,
    isRefetching: isRefetchingTransferOutFees,
  } = useGetEstimateSavingTransferOutFee({
    amount: Number(goalTransferOut.cryptoAmount.amount),
    currency: goalTransferOut.cryptoAmount.code as any,
    transfer_type: isInstantTransfer ? 'instant' : 'regular',
  })

  const { data: featureSettings } = useGetFeaturesSettings()

  useEffect(() => {
    if (transferOutFees) {
      setGoalTransferOut({
        saving_request_id: transferOutFees.saving_request_id,
        total_amount: {
          amount: transferOutFees.amount.amount,
          code: transferOutFees.amount.currency,
        },
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [transferOutFees])

  return (
    <>
      <BaseView
        data-component="transfer-out-settings-and-fees"
        row
        align="center"
        justify="space-between"
        mt={20}
      >
        <BaseView gap={8}>
          <BaseText color="label.description" fontFamily="semibold">
            {t('translation:transferOut.instantTransfer')}
          </BaseText>
          <BaseText color="label.description">
            {t('translation:transferOut.instantTransferDescription')}
          </BaseText>
        </BaseView>

        <Toggle isActive={isInstantTransfer} onToggle={setIsInstantTransfer} />
      </BaseView>

      {/* <Separator /> */}

      <BaseView gap={16}>
        {!isInstantTransfer &&
          !!featureSettings?.savings?.regular_transfer_delay && (
            <RowItem
              labelProps={{
                color: 'label.default',
              }}
              valueProps={{
                color: 'label.default',
              }}
              label="transferOut.timeToTransferOut"
              value={
                featureSettings.savings_regular_transfer_delay_formatted || ''
              }
              skeletonActive={
                isLoadingTransferOutFees || isRefetchingTransferOutFees
              }
            />
          )}

        <RowItem
          labelProps={{
            color: 'label.disabled',
          }}
          valueProps={{
            color: 'label.disabled',
          }}
          label="transferOut.transactionFee"
          value={transferOutFees?.formattedTransactionFee ?? ''}
          skeletonActive={
            isLoadingTransferOutFees || isRefetchingTransferOutFees
          }
        />

        <RowItem
          labelProps={{
            color: 'label.default',
          }}
          label="transferOut.totalYouWillGet"
          value={transferOutFees?.formattedTotalReceived ?? ''}
          skeletonActive={
            isLoadingTransferOutFees || isRefetchingTransferOutFees
          }
        />
      </BaseView>

      {/* <Separator /> */}
    </>
  )
}
